import { render, staticRenderFns } from "./RevenuesDate.vue?vue&type=template&id=298d20b8&"
import script from "./RevenuesDate.vue?vue&type=script&lang=js&"
export * from "./RevenuesDate.vue?vue&type=script&lang=js&"
import style0 from "./RevenuesDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports